import Vue from 'vue'

const getClientes = async () => {
  try {
    const response = await Vue.prototype.$http.get(`/clientes`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getPedidosCliente = async (codCliente) => {
  try {
    const response = await Vue.prototype.$http.get(`/cliente/${codCliente}/pedidos`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

export {
  getClientes,
  getPedidosCliente
}